// https://tabler.io/icons
import { motion } from "framer-motion";
import { containerDraw, pathDraw } from "./heroIconsMotions";


export const Rainbow = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      d="M22 17c0 -5.523 -4.477 -10 -10 -10c-5.523 0 -10 4.477 -10 10"
    />
    <motion.path variants={pathDraw} d="M18 17a6 6 0 1 0 -12 0" />
    <motion.path variants={pathDraw} d="M14 17a2 2 0 1 0 -4 0" />
  </motion.svg>
);

export const BabyFace = () => {
  return (
    <motion.svg
      width="100" // Increased size for visibility
      height="100"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      initial="hidden"
      animate="visible"
    >
      <motion.path
        variants={pathDraw}
        d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
      />
      <motion.path variants={pathDraw} d="M9 10l.01 0" />
      <motion.path variants={pathDraw} d="M15 10l.01 0" />
      <motion.path variants={pathDraw} d="M9.5 15a3.5 3.5 0 0 0 5 0" />
      <motion.path variants={pathDraw} d="M12 3a2 2 0 0 0 0 4" />
    </motion.svg>
  );
};

export const Bottle = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path variants={pathDraw} d="M5 10h14" />
    <motion.path variants={pathDraw} d="M12 2v2" />
    <motion.path
      variants={pathDraw}
      d="M12 4a5 5 0 0 1 5 5v11a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-11a5 5 0 0 1 5 -5"
    />
  </motion.svg>
);

export const Sun = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path variants={pathDraw} d="M8 12a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
    <motion.path
      variants={pathDraw}
      d="M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7"
    />
  </motion.svg>
);

export const Horse = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path
      variants={pathDraw}
      d="M3.5 17.5c5.667 4.667 11.333 4.667 17 0"
    />
    <motion.path
      variants={pathDraw}
      d="M19 18.5l-2 -8.5l1 -2l2 1l1.5 -1.5l-2.5 -4.5c-5.052 .218 -5.99 3.133 -7 6h-6a3 3 0 0 0 -3 3"
    />
    <motion.path variants={pathDraw} d="M5 18.5l2 -9.5" />
    <motion.path variants={pathDraw} d="M8 20l2 -5h4l2 5" />
  </motion.svg>
);

export const Balloon = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path variants={pathDraw} d="M14 8a2 2 0 0 0 -2 -2" />
    <motion.path
      variants={pathDraw}
      d="M6 8a6 6 0 1 1 12 0c0 4.97 -2.686 9 -6 9s-6 -4.03 -6 -9"
    />
    <motion.path
      variants={pathDraw}
      d="M12 17v1a2 2 0 0 1 -2 2h-3a2 2 0 0 0 -2 2"
    />
  </motion.svg>
);

export const Cake = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path
      variants={pathDraw}
      d="M3 20h18v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3v8"
    />
    <motion.path
      variants={pathDraw}
      d="M3 14.803c.312 .135 .654 .204 1 .197a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1c.35 .007 .692 -.062 1 -.197"
    />
    <motion.path
      variants={pathDraw}
      d="M12 4l1.465 1.638a2 2 0 1 1 -3.015 .099l1.55 -1.737"
    />
  </motion.svg>
);

export const Gift = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path
      variants={pathDraw}
      d="M3 9a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1l0 -2"
    />
    <motion.path variants={pathDraw} d="M12 8l0 13" />
    <motion.path
      variants={pathDraw}
      d="M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7"
    />
    <motion.path
      variants={pathDraw}
      d="M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5"
    />
  </motion.svg>
);

export const Stroller = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path variants={pathDraw} d="M6 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <motion.path variants={pathDraw} d="M16 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <motion.path
      variants={pathDraw}
      d="M2 5h2.5l1.632 4.897a6 6 0 0 0 5.693 4.103h2.675a5.5 5.5 0 0 0 0 -11h-.5v6"
    />
    <motion.path variants={pathDraw} d="M6 9h14" />
    <motion.path variants={pathDraw} d="M9 17l1 -3" />
    <motion.path variants={pathDraw} d="M16 14l1 3" />
  </motion.svg>
);

export const Paw = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path
      variants={pathDraw}
      d="M14.7 13.5c-1.1 -2 -1.441 -2.5 -2.7 -2.5c-1.259 0 -1.736 .755 -2.836 2.747c-.942 1.703 -2.846 1.845 -3.321 3.291c-.097 .265 -.145 .677 -.143 .962c0 1.176 .787 2 1.8 2c1.259 0 3 -1 4.5 -1s3.241 1 4.5 1c1.013 0 1.8 -.823 1.8 -2c0 -.285 -.049 -.697 -.146 -.962c-.475 -1.451 -2.512 -1.835 -3.454 -3.538"
    />
    <motion.path
      variants={pathDraw}
      d="M20.188 8.082a1.039 1.039 0 0 0 -.406 -.082h-.015c-.735 .012 -1.56 .75 -1.993 1.866c-.519 1.335 -.28 2.7 .538 3.052c.129 .055 .267 .082 .406 .082c.739 0 1.575 -.742 2.011 -1.866c.516 -1.335 .273 -2.7 -.54 -3.052l-.001 0"
    />
    <motion.path
      variants={pathDraw}
      d="M9.474 9c.055 0 .109 0 .163 -.011c.944 -.128 1.533 -1.346 1.32 -2.722c-.203 -1.297 -1.047 -2.267 -1.932 -2.267c-.055 0 -.109 0 -.163 .011c-.944 .128 -1.533 1.346 -1.32 2.722c.204 1.293 1.048 2.267 1.933 2.267"
    />
    <motion.path
      variants={pathDraw}
      d="M16.456 6.733c.214 -1.376 -.375 -2.594 -1.32 -2.722a1.164 1.164 0 0 0 -.162 -.011c-.885 0 -1.728 .97 -1.93 2.267c-.214 1.376 .375 2.594 1.32 2.722c.054 .007 .108 .011 .162 .011c.885 0 1.73 -.974 1.93 -2.267"
    />
    <motion.path
      variants={pathDraw}
      d="M5.69 12.918c.816 -.352 1.054 -1.719 .536 -3.052c-.436 -1.124 -1.271 -1.866 -2.009 -1.866c-.14 0 -.277 .027 -.407 .082c-.816 .352 -1.054 1.719 -.536 3.052c.436 1.124 1.271 1.866 2.009 1.866c.14 0 .277 -.027 .407 -.082"
    />
  </motion.svg>
);

export const Shoe = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path
      variants={pathDraw}
      d="M4 6h5.426a1 1 0 0 1 .863 .496l1.064 1.823a3 3 0 0 0 1.896 1.407l4.677 1.114a4 4 0 0 1 3.074 3.89v2.27a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1"
    />
    <motion.path variants={pathDraw} d="M14 13l1 -2" />
    <motion.path variants={pathDraw} d="M8 18v-1a4 4 0 0 0 -4 -4h-1" />
    <motion.path variants={pathDraw} d="M10 12l1.5 -3" />
  </motion.svg>
);

export const Book = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path variants={pathDraw} d="M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0" />
    <motion.path variants={pathDraw} d="M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0" />
    <motion.path variants={pathDraw} d="M3 6l0 13" />
    <motion.path variants={pathDraw} d="M12 6l0 13" />
    <motion.path variants={pathDraw} d="M21 6l0 13" />
  </motion.svg>
);

export const Letter = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path
      variants={pathDraw}
      d="M14 15.5a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0"
    />
    <motion.path variants={pathDraw} d="M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5" />
    <motion.path variants={pathDraw} d="M3 13h7" />
    <motion.path variants={pathDraw} d="M21 12v7" />
  </motion.svg>
);

export const Moon = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path
      variants={pathDraw}
      d="M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454l0 .008"
    />
  </motion.svg>
);

export const Sleep = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path variants={pathDraw} d="M4 12h6l-6 8h6" />
    <motion.path variants={pathDraw} d="M14 4h6l-6 8h6" />
  </motion.svg>
);

export const Bed = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path variants={pathDraw} d="M5 9a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <motion.path variants={pathDraw} d="M22 17v-3h-20" />
    <motion.path variants={pathDraw} d="M2 8v9" />
    <motion.path variants={pathDraw} d="M12 14h10v-2a3 3 0 0 0 -3 -3h-7v5" />
  </motion.svg>
);

export const Car = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path variants={pathDraw} d="M5 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <motion.path variants={pathDraw} d="M15 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <motion.path
      variants={pathDraw}
      d="M5 17h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5"
    />
  </motion.svg>
);

export const Bus = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path variants={pathDraw} d="M4 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <motion.path variants={pathDraw} d="M16 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <motion.path
      variants={pathDraw}
      d="M4 17h-2v-11a1 1 0 0 1 1 -1h14a5 7 0 0 1 5 7v5h-2m-4 0h-8"
    />
    <motion.path variants={pathDraw} d="M16 5l1.5 7l4.5 0" />
    <motion.path variants={pathDraw} d="M2 10l15 0" />
    <motion.path variants={pathDraw} d="M7 5l0 5" />
    <motion.path variants={pathDraw} d="M12 5l0 5" />
  </motion.svg>
);

export const Road = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path variants={pathDraw} d="M4 19l4 -14" />
    <motion.path variants={pathDraw} d="M16 5l4 14" />
    <motion.path variants={pathDraw} d="M12 8v-2" />
    <motion.path variants={pathDraw} d="M12 13v-2" />
    <motion.path variants={pathDraw} d="M12 18v-2" />
  </motion.svg>
);

export const Heart = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path
      variants={pathDraw}
      d="M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"
    />
  </motion.svg>
);

export const Silence = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path
      variants={pathDraw}
      d="M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18"
    />
    <motion.path variants={pathDraw} d="M9 10h-.01" />
    <motion.path variants={pathDraw} d="M15 10h-.01" />
    <motion.path variants={pathDraw} d="M8 15h8" />
    <motion.path variants={pathDraw} d="M9 14v2" />
    <motion.path variants={pathDraw} d="M12 14v2" />
    <motion.path variants={pathDraw} d="M15 14v2" />
  </motion.svg>
);

export const Sad = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path variants={pathDraw} d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
    <motion.path variants={pathDraw} d="M9 13h.01" />
    <motion.path variants={pathDraw} d="M15 13h.01" />
    <motion.path variants={pathDraw} d="M11 17h2" />
  </motion.svg>
);

export const Happy = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path variants={pathDraw} d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
    <motion.path variants={pathDraw} d="M9 9l.01 0" />
    <motion.path variants={pathDraw} d="M15 9l.01 0" />
    <motion.path variants={pathDraw} d="M8 13a4 4 0 1 0 8 0h-8" />
  </motion.svg>
);

export const Dog = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path variants={pathDraw} d="M11 5h2" />
    <motion.path
      variants={pathDraw}
      d="M19 12c-.667 5.333 -2.333 8 -5 8h-4c-2.667 0 -4.333 -2.667 -5 -8"
    />
    <motion.path
      variants={pathDraw}
      d="M11 16c0 .667 .333 1 1 1s1 -.333 1 -1h-2"
    />
    <motion.path variants={pathDraw} d="M12 18v2" />
    <motion.path variants={pathDraw} d="M10 11v.01" />
    <motion.path variants={pathDraw} d="M14 11v.01" />
    <motion.path
      variants={pathDraw}
      d="M5 4l6 .97l-6.238 6.688a1.021 1.021 0 0 1 -1.41 .111a.953 .953 0 0 1 -.327 -.954l1.975 -6.815"
    />
    <motion.path
      variants={pathDraw}
      d="M19 4l-6 .97l6.238 6.688c.358 .408 .989 .458 1.41 .111a.953 .953 0 0 0 .327 -.954l-1.975 -6.815"
    />
  </motion.svg>
);

export const Cat = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path
      variants={pathDraw}
      d="M20 3v10a8 8 0 1 1 -16 0v-10l3.432 3.432a7.963 7.963 0 0 1 4.568 -1.432c1.769 0 3.403 .574 4.728 1.546l3.272 -3.546"
    />
    <motion.path variants={pathDraw} d="M2 16h5l-4 4" />
    <motion.path variants={pathDraw} d="M22 16h-5l4 4" />
    <motion.path variants={pathDraw} d="M11 16a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
    <motion.path variants={pathDraw} d="M9 11v.01" />
    <motion.path variants={pathDraw} d="M15 11v.01" />
  </motion.svg>
);

export const Confetti = () => (
  <motion.svg
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    variants={containerDraw}
    initial="hidden"
    animate="visible"
  >
    <motion.path
      variants={pathDraw}
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <motion.path variants={pathDraw} d="M4 5h2" />
    <motion.path variants={pathDraw} d="M5 4v2" />
    <motion.path variants={pathDraw} d="M11.5 4l-.5 2" />
    <motion.path variants={pathDraw} d="M18 5h2" />
    <motion.path variants={pathDraw} d="M19 4v2" />
    <motion.path variants={pathDraw} d="M15 9l-1 1" />
    <motion.path variants={pathDraw} d="M18 13l2 -.5" />
    <motion.path variants={pathDraw} d="M18 19h2" />
    <motion.path variants={pathDraw} d="M19 18v2" />
    <motion.path
      variants={pathDraw}
      d="M14 16.518l-6.518 -6.518l-4.39 9.58a1 1 0 0 0 1.329 1.329l9.579 -4.39"
    />
  </motion.svg>
);
